export function getLocation() {
  if (!navigator.location) {
    return false;
  }

  const currentPosition = navigator.geolocation.getCurrentPosition(
    (position) => {
      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    }
  );

  return currentPosition;
}

export function findLatLonDifference({ coordinates1, coordinates2 }) {
  const latDiff = Math.abs(coordinates1.lat - coordinates2?.lat);
  const lonDiff = Math.abs(coordinates1.lon - coordinates2?.lon);

  const averageDiff = (latDiff + lonDiff) / 2;

  return { latDiff, lonDiff, averageDiff };
}

export function findLatLonDifferenceBoundingBox({ boundingBox, coordinates }) {
  const north = boundingBox[3];
  const east = boundingBox[2];
  const south = boundingBox[1];
  const west = boundingBox[0];

  const {
    latDiff: latDiffNorth,
    lonDiff: lonDiffEast,
    averageDiff: averageDiffNorthEast,
  } = findLatLonDifference({
    coordinates1: coordinates,
    coordinates2: {
      lat: north,
      lon: east,
    },
  });

  const {
    latDiff: latDiffSouth,
    lonDiff: lonDiffWest,
    averageDiff: averageDiffSouthWest,
  } = findLatLonDifference({
    coordinates1: coordinates,
    coordinates2: {
      lat: south,
      lon: west,
    },
  });

  return {
    north: latDiffNorth,
    east: lonDiffEast,
    south: latDiffSouth,
    west: lonDiffWest,
    averageDiffNorthEast,
    averageDiffSouthWest,
  };
}

export function areCoordinatesInsideBoundingBox({ coordinates, boundingBox }) {
  const { lat, lon } = coordinates;
  const boundingBoxCrosses180Meridian = boundingBox[0] > boundingBox[2];
  const longitudeDistanceFrom180 = 180 - Math.abs(lon);
  const westDistanceFrom180 = 180 - Math.abs(boundingBox[0]);
  const eastDistanceFrom180 = 180 - Math.abs(boundingBox[2]);

  const isInLatitudeRange = lat >= boundingBox[1] && lat <= boundingBox[3];
  const isInLongitudeRange = !boundingBoxCrosses180Meridian
    ? lon >= boundingBox[0] && lon <= boundingBox[2]
    : longitudeDistanceFrom180 < westDistanceFrom180 &&
      longitudeDistanceFrom180 < eastDistanceFrom180;

  const isInsideBoundingBox = isInLatitudeRange && isInLongitudeRange;

  return isInsideBoundingBox;
}

export function calculateExpandedBoundingBox({ boundingBox, expandingFactor }) {
  const north = boundingBox[3];
  const east = boundingBox[2];
  const south = boundingBox[1];
  const west = boundingBox[0];

  const expandedBoundingBox = [
    west - expandingFactor,
    south - expandingFactor,
    east + expandingFactor,
    north + expandingFactor,
  ];

  return expandedBoundingBox;
}

export function calculateBoundingDiameters({ boundingBox }) {
  const north = boundingBox[3];
  const east = boundingBox[2];
  const south = boundingBox[1];
  const west = boundingBox[0];

  const boxCrosses180Meridian = west > east;

  const vertical = north - south;
  const horizontal = !boxCrosses180Meridian ? east - west : 360 - west + east;
  const hypotenuse = Math.sqrt(vertical ** 2 + horizontal ** 2);

  return { vertical, horizontal, hypotenuse };
}
